var chunkMapping = {
	"3": [
		1375
	],
	"38": [
		6565
	],
	"72": [
		7072
	],
	"166": [
		7573
	],
	"234": [
		947
	],
	"244": [
		681
	],
	"365": [
		4355
	],
	"421": [
		5735
	],
	"464": [
		3637
	],
	"529": [
		2843
	],
	"659": [
		865
	],
	"703": [
		8773
	],
	"741": [
		5895
	],
	"791": [
		6113
	],
	"891": [
		5457
	],
	"990": [
		2117
	],
	"993": [
		6045
	]
};
var idToExternalAndNameMapping = {
	"681": [
		"default",
		"./HeaderApp",
		8831
	],
	"865": [
		"default",
		"./EcommerceApp",
		8921
	],
	"947": [
		"default",
		"./AuthApp",
		7157
	],
	"1375": [
		"default",
		"./BookingBuilderApp",
		9357
	],
	"2117": [
		"default",
		"./EmailBuilderApp",
		4523
	],
	"2843": [
		"default",
		"./CustomerAuthenticationApp",
		6609
	],
	"3637": [
		"default",
		"./DynamicFormsAdminApp",
		8021
	],
	"4355": [
		"default",
		"./DynamicFormsApp",
		2481
	],
	"5457": [
		"default",
		"./SidebarApp",
		53
	],
	"5735": [
		"default",
		"./ServicesApp",
		9217
	],
	"5895": [
		"default",
		"./WebsiteBuilderApp",
		9729
	],
	"6045": [
		"default",
		"./POSApp",
		4665
	],
	"6113": [
		"default",
		"./MarketingApp",
		7249
	],
	"6565": [
		"default",
		"./OffersApp",
		5487
	],
	"7072": [
		"default",
		"./IdleSessionApp",
		6207
	],
	"7573": [
		"default",
		"./POSBackOfficeApp",
		6753
	],
	"8773": [
		"default",
		"./ProductManagementApp",
		5737
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}